<template>
  <div class="filters__block filters__sortby">
    <button
      type="button"
      class="filter__trigger"
      @click="togglePanel()"
    >
      Sort
      <span
        class="filter__icon"
        :class="{'rotate': toggleSortBy}"
      >
        <svg
          width="14"
          height="8"
          viewBox="0 0 14 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 1L7 7L13 1"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
    </button>
    <div
      class="filter__panel"
      :class="{'is--hidden': !toggleSortBy}"
    >
      <div
        class="filter__input-group"
        @click="setSort('-ga_item_quantity_mintvelvet_28_days')"
      >
        <div class="filter__radio-container">
          <input
            id="filter--popularity"
            type="radio"
            class="filter__checkbox--not--round filter__radio--round"
            name="filter-sort_by"
            :checked="isSortSelected('-ga_item_quantity_mintvelvet_28_days')"
          >
        </div>
        <label
          for="filter--popularity"
          class="filter__label"
        >Popularity</label>
      </div>
      <div
        class="filter__input-group"
        @click="setSort(this.priceField)"
      >
        <div class="filter__radio-container">
          <input
            id="filter--price-low-high"
            type="radio"
            class="filter__checkbox--not--round filter__radio--round"
            name="filter-sort_by"
            :checked="isSortSelected(this.priceField)"
          >
        </div>
        <label
          for="filter--price-low-high"
          class="filter__label"
        >Price (low to high)</label>
      </div>
      <div
        class="filter__input-group"
        @click="setSort(`-${this.priceField}`)"
      >
        <div class="filter__radio-container">
          <input
            id="filter--price-high-low"
            type="radio"
            class="filter__checkbox--not--round filter__radio--round"
            name="filter-sort_by"
            :checked="isSortSelected(`-${this.priceField}`)"
          >
        </div>
        <label
          for="filter--price-high-low"
          class="filter__label"
        >Price (high to low)</label>
      </div>

      <div
        class="filter__input-group"
        @click="setSort('days_on_site')"
      >
        <div class="filter__radio-container">
          <input
            id="filter--price-new-in"
            type="radio"
            class="filter__checkbox--round"
            name="filter-sort_by"
            :checked="isSortSelected('days_on_site')"
          >
        </div>
        <label
          for="filter--price-new-in"
          class="filter__label"
        >Newness</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SortByFilterBlock',
  delimiters: ['{$', '$}'],
  props: {

  },

  data(){
    return {
      toggleSortBy: false,
      sortBy_: '-ga_item_quantity_mintvelvet_28_days',
      priceField: window.mint.services.attraqt.priceField
    }
  },
  methods: {
    togglePanel: function() {
      this.toggleSortBy = !this.toggleSortBy;
    },

    setSort(value) {
      this.sortBy_ = value
      this.$emit('sortByOrder', value)
    },

    isSortSelected(value) {
      return this.sortBy_ == value;
    }
  },
  mounted() {
    // Grab the current param
    const currentSearchParam = new URLSearchParams(window.location.search);
    const sortBy = currentSearchParam.get("fh_sort_by")

    if(sortBy) {
      this.sortBy_ = sortBy;
    }
  }

}
</script>

<style lang="scss">
 .rotate {
    transform: rotateX(180deg);
    transition: .21s;
 }
</style>
